'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import Small from 'UIComponents/elements/Small';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import * as CustomWidgetBufferActions from 'DesignData/actions/CustomWidgetBuffers';
import * as CustomWidgetEditorOptionsActions from 'DesignData/actions/CustomWidgetEditorOptions';
import { getFieldGrouping } from 'DesignData/selectors/customWidgetEditorOptions';
import { MAX_NESTING_DEPTH } from 'DesignData/constants/CustomWidgets';
import { GROUP } from 'ContentUtils/constants/CustomWidgetFieldTypes';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.main.fieldGrouping.${key}`;

function makeMapStateToProps() {
  return (state, props) => {
    return {
      fieldGrouping: getFieldGrouping(state, props)
    };
  };
}

const mapDispatchToProps = {
  createFieldGroup: CustomWidgetBufferActions.createFieldGroup,
  toggleFieldGrouping: CustomWidgetEditorOptionsActions.toggleFieldGrouping
};

class FieldGrouping extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onCancelClick = () => {
      const {
        customWidgetId,
        toggleFieldGrouping
      } = this.props;
      toggleFieldGrouping(customWidgetId);
    };

    this.onCreateGroupClick = () => {
      const {
        createFieldGroup,
        customWidgetId,
        fieldGrouping
      } = this.props;
      const {
        selectedFields
      } = fieldGrouping;

      if (!Object.keys(selectedFields).length) {
        return;
      }

      const fieldGroup = new CustomWidgetField({
        type: GROUP,
        isNew: true
      });
      createFieldGroup(customWidgetId, fieldGroup, selectedFields);
    };
  }

  render() {
    const {
      selectedFields,
      fieldsAreNotSiblings,
      isTooDeep
    } = this.props.fieldGrouping;
    const isInvalidGrouping = !Object.keys(selectedFields).length || fieldsAreNotSiblings || isTooDeep;

    const fieldsAreNotSiblingsMessage = fieldsAreNotSiblings && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Small, {
        use: "error",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('fieldsAreNotSiblingsMessage')
        })
      })
    });

    const isTooDeepMessage = isTooDeep && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Small, {
        use: "error",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('isTooDeepMessage'),
          options: {
            maxNestingDepth: MAX_NESTING_DEPTH
          }
        })
      })
    });

    return /*#__PURE__*/_jsxs("div", {
      className: "sidebar-group-controls",
      children: [/*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('message')
        })
      }), fieldsAreNotSiblingsMessage, isTooDeepMessage, /*#__PURE__*/_jsxs("div", {
        className: "p-top-2",
        children: [/*#__PURE__*/_jsx(UIButton, {
          disabled: isInvalidGrouping,
          onClick: this.onCreateGroupClick,
          size: "small",
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('buttons.createGroup')
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: this.onCancelClick,
          size: "small",
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('buttons.cancel')
          })
        })]
      })]
    });
  }

}

FieldGrouping.propTypes = {
  createFieldGroup: PropTypes.func.isRequired,
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  toggleFieldGrouping: PropTypes.func.isRequired,
  fieldGrouping: PropTypes.object.isRequired
};
export default connect(makeMapStateToProps, mapDispatchToProps)(FieldGrouping);